/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartyOptionRes } from '../../models/party-option-res';

export interface ApiUserOptPartiesGet$Params {
}

export function apiUserOptPartiesGet(http: HttpClient, rootUrl: string, params?: ApiUserOptPartiesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartyOptionRes>>> {
  const rb = new RequestBuilder(rootUrl, apiUserOptPartiesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PartyOptionRes>>;
    })
  );
}

apiUserOptPartiesGet.PATH = '/api/User/opt/parties';
